export const enum FollowNotificationFrequency {
    ALL = "all",
    SMART = "smart",
    NONE = "none",
}

export interface IFollowing {
    roomName: string
    following: boolean
    followNotificationFrequency: FollowNotificationFrequency
    onlineCount?: number
    totalCount?: number
}
